import React, { useContext, useEffect, useRef, useState } from "react";
import UserList from "./UserList";
import UnitFilter from "./UnitFilter";
import RecordStatusFilter from "./RecordStatusFilter";
import HealthcareWorkerFilter from "./HealthcareWorkerFilter";
import DateFilter from "./DateFilter";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Paper, Typography } from "@mui/material";

import styles from "../../styles.module.css";
import { Button } from "@material-ui/core";
import { viewportContext } from "../../context/ViewportContext";
import clsx from "clsx";
import MomentFilter from "./MomentFilter";
import OutcomeFilter from "./OutcomeFilter";
const useStyles = makeStyles((theme) => ({
  container: {
    margin: "20px",
    padding: "20px",
  },
}));

const HHDataFiltersComponent = ({
  selectedUser,
  setSelectedUser,
  selectedUnit,
  setSelectedUnit,
  units,
  setUnits,
  recordStatus,
  setRecordStatus,
  selectedHealthcareWorker,
  setSelectedHealthcareWorker,
  selectedMoment,
  setSelectedMoment,
  selectedOutcome,
  setSelectedOutcome,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  resetFilters,
}) => {
  const classes = useStyles();
  const [showFilter, setShowFilter] = useState(false);
  const { screenType } = useContext(viewportContext);
  const paperRef = useRef(null);

  const handleClickOutside = (event) => {
    if (paperRef.current && !paperRef.current.contains(event.target)) {
      setShowFilter(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const renderGrid = () => {
    return (
      <Grid container alignItems="center">
        <Grid
          item
          xs={12}
          sm={2}
          className={clsx(styles.flexCenter, styles.filterButtonMargin)}
        >
          <UserList
            selectedUser={selectedUser}
            setSelectedUser={setSelectedUser}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={2}
          className={clsx(styles.flexCenter, styles.filterButtonMargin)}
        >
          <UnitFilter
            selectedUnit={selectedUnit}
            setSelectedUnit={setSelectedUnit}
            units={units}
            setUnits={setUnits}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={2}
          className={clsx(styles.flexCenter, styles.filterButtonMargin)}
        >
          <RecordStatusFilter
            recordStatus={recordStatus}
            setRecordStatus={setRecordStatus}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={2}
          className={clsx(styles.flexCenter, styles.filterButtonMargin)}
        >
          <HealthcareWorkerFilter
            selectedHealthcareWorker={selectedHealthcareWorker}
            setSelectedHealthcareWorker={setSelectedHealthcareWorker}
          />
        </Grid>

        <Grid
          item
          xs={12}
          sm={4}
          className={clsx(styles.flexCenter, styles.filterButtonMargin)}
        >
          <DateFilter
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={2}
          className={clsx(styles.flexCenter, styles.filterButtonMargin)}
        >
          <MomentFilter
            selectedMoment={selectedMoment}
            setSelectedMoment={setSelectedMoment}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={2}
          className={clsx(styles.flexCenter, styles.filterButtonMargin)}
        >
          <OutcomeFilter
            selectedOutcome={selectedOutcome}
            setSelectedOutcome={setSelectedOutcome}
          />
        </Grid>
      </Grid>
    );
  };

  return (
    <Paper className={styles.paperStyles}>
      {screenType.isMobile ? (
        <>
          <div className={styles.filterRow}>
            <Typography variant="h5">Filters</Typography>
            <Button
              className={styles.secondaryButton}
              onClick={() => setShowFilter(!showFilter)}
            >
              Filters
            </Button>
          </div>
          {showFilter && (
            <Paper ref={paperRef} className={styles.filterPaperStyles}>
              {renderGrid()}
            </Paper>
          )}
        </>
      ) : (
        <>
          <div className={styles.filterRow}>
            <Typography variant="h5">Filters</Typography>
            <Button
              className={styles.secondaryButton}
              onClick={() => resetFilters()}
            >
              Reset Filters
            </Button>
          </div>
          {renderGrid()}
        </>
      )}
    </Paper>
  );
};

export default HHDataFiltersComponent;
